<template>
  <div>
    <b-card class="m-3">
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="titulo-sagres font-weight-bold"
            >Cadastrar Alteração Normativa</span
          >
          <btn-voltar />
        </h6>
      </template>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(alterarCargo)">
          <b-row class="mt-2">
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Tipo de Alteração normativa"
                v-slot="defaultState"
              >
                <b-form-select
                  :state="defaultState.state"
                  v-model="cargo.tipoAlteracao"
                  :options="tiposAlteracaoNormativa"
                  @change="handleTipoAlteracaoNormativaChange()"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col v-if="cargo.tipoAlteracao != 3" cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Vagas Criadas ou Reduzidas"
                v-slot="defaultState"
              >
                <b-form-input
                  :state="defaultState.state"
                  v-model="cargo.vagasCriadasOuReduzidas"
                  type="number"
                  min="1"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Código"
                v-slot="defaultState"
              >
                <b-form-input
                  :state="defaultState.state"
                  v-model="cargo.codigoCargo"
                  type="text"
                  disabled
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Vínculo"
                v-slot="defaultState"
              >
                <b-form-select
                  :state="defaultState.state"
                  v-model="cargo.vinculo"
                  :options="tiposVinculo"
                  :disabled="criacaoOuReducaoDeVagas"
                  @change="handleVinculoChange"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Nomenclatura"
                v-slot="defaultState"
              >
                <b-form-input
                  v-if="nomenclaturaTextoLivre"
                  v-b-tooltip.click.bottom
                  v-b-tooltip.blur.bottom
                  title="Igual ao Normativo"
                  :state="defaultState.state"
                  v-model="nomenclaturaInput"
                  type="text"
                  :disabled="criacaoOuReducaoDeVagas"
                  @blur="verificarNomenclatura(nomenclaturaInput)"
                />
                <b-form-select
                  v-else
                  :state="defaultState.state"
                  v-model="cargo.nomenclaturaCargo"
                  :options="tiposNomenclatura"
                  :disabled="criacaoOuReducaoDeVagas"
                  @change="verificarNomenclatura(cargo.nomenclaturaCargo)"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Situação da Vaga"
                v-slot="defaultState"
              >
                <b-form-select
                  :state="defaultState.state"
                  v-model="cargo.situacaoCargo"
                  :options="tiposSituacao"
                  :disabled="criacaoOuReducaoDeVagas"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Escolaridade Exigida"
                v-slot="defaultState"
              >
                <b-form-select
                  :state="defaultState.state"
                  v-model="cargo.escolaridade"
                  :options="tiposEscolaridade"
                  :disabled="criacaoOuReducaoDeVagas"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Quantidade de Vagas Existentes"
                v-slot="defaultState"
              >
                <b-form-input
                  v-model="cargo.quantidadeVagas"
                  :state="defaultState.state"
                  type="number"
                  min="1"
                  disabled
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Regime Jurídico"
                v-slot="defaultState"
              >
                <b-form-select
                  :state="defaultState.state"
                  v-model="cargo.regimeJuridico"
                  :options="tiposRegimeJuridico"
                  :disabled="criacaoOuReducaoDeVagas || cargo.vinculo == null"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Natureza"
                v-slot="defaultState"
              >
                <b-form-select
                  :state="defaultState.state"
                  v-model="cargo.naturezaCargo"
                  :options="tiposNatureza"
                  :disabled="criacaoOuReducaoDeVagas || cargo.vinculo == null"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Regime Previdenciário"
                v-slot="defaultState"
              >
                <b-form-select
                  :state="defaultState.state"
                  v-model="cargo.regimePrevidenciario"
                  :options="tiposRegimePrevidenciario"
                  :disabled="criacaoOuReducaoDeVagas"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col v-if="mostrarInputCargaHoraria" cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Carga Horária Semanal"
                v-slot="defaultState"
              >
                <b-form-input
                  :state="defaultState.state"
                  v-model="cargo.cargaHoraria"
                  type="number"
                  min="1"
                  max="70"
                  :disabled="criacaoOuReducaoDeVagas"
                />
              </default-form-validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="6" xl="4" class="addNormativoBtnWrapper">
              <b-button
                :disabled="temNormativo"
                @click="$bvModal.show('modal')"
              >
                <font-awesome-icon icon="plus" class="mr-2" />Adicionar
                Normativo
              </b-button>
            </b-col>
            <b-col cols="8" />
          </b-row>
          <div v-if="temNormativo" id="infoNormativoWrapper">
            <span><b>Informações do normativo</b></span>
            <b-alert
              v-if="normativoNaoEncontrado"
              show
              dismissible
              variant="warning"
            >
              <strong>Atenção! </strong>Ato Normativo não encontrado na base de
              dados. Para cadastrar um novo Ato Normativo, clique
              <button
                type="button"
                class="btnCadastroLegislacoes"
                @click="$bvModal.show('modal-cadastro-legislacao')"
              >
                aqui
              </button>
            </b-alert>
            <b-table
              :fields="camposNormativo"
              striped
              hover
              no-border-collapse
              :items="normativoAdicionado"
              small
            >
              <template v-slot:cell(actions)="">
                <div class="actions-icons">
                  <div class="wrapper-icon" @click="alertaRemoveNormativo()">
                    <font-awesome-icon icon="trash" />
                    <div style="font-size: 12px">Excluir</div>
                  </div>
                </div>
              </template>
            </b-table>
          </div>
          <b-row>
            <b-col>
              <b-button type="submit">
                <font-awesome-icon icon="save" class="mr-2" />Salvar
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>

    <modal-adicionar-normativo
      :tiposAtoNormativo="tiposAtoNormativo"
      :tiposVeiculoPublicacao="tiposVeiculoPublicacao"
      @salvar="salvarNormativo"
    />
    <modal-cadastro-legislacao @fechar="fecharModalLegislacoes" />
    <modal-nomenclatura-duplicada @sair="$router.go(-1)" />
  </div>
</template>

<script lang="ts">
import { ValidationObserver } from "vee-validate";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import cargoService from "@/services/atos-pessoal/cargoService";
import {
  carregarTipoVinculo,
  carregarTipoRegimeJuridico,
  carregarTipoRegimePrevidenciario,
  carregarTipoNatureza,
  carregarTipoEscolaridade,
  carregarTipoSituacao,
  carregarTipoAtoNormativo,
  carregarTipoAlteracaoNormativa,
  carregarTipoVeiculoPublicacaoNormativo,
} from "./utils";
import { store } from "@/store";
import BtnVoltar from "@/components/shared/BtnVoltar.vue";
import { UtilsTS } from "@/utilsts";
import ModalAdicionarNormativo from "@/components/atos-pessoal/cargos/ModalAdicionarNormativo.vue";
import ModalCadastroLegislacao from "@/components/atos-pessoal/cargos/ModalCadastroLegislacao.vue";
import ModalNomenclaturaDuplicada from "@/components/atos-pessoal/cargos/ModalNomenclaturaDuplicada.vue";
import { Component, Ref, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { TableField } from "@/types/table-field";
import { fieldsNormativoAdicionado } from "@/types/atos-pessoal/cargos/fields-normativo-adicionado";
import { SelectValue } from "@/types/select-value";
import { NormativoCargo } from "@/types/atos-pessoal/cargos/normativo-cargo";
import { TabelasAuxiliaresCargo } from "@/types/atos-pessoal/cargos/tabelas-auxiliares-cargo";
import { CargoAlterarNormativa } from "@/types/atos-pessoal/cargos/cargo-alterar-normativa";

const CompProps = Vue.extend({
  name: "AlteracaoNormativa",
  components: {
    ValidationObserver,
    DefaultFormValidationProvider,
    BtnVoltar,
    ModalAdicionarNormativo,
    ModalCadastroLegislacao,
    ModalNomenclaturaDuplicada,
  },
  props: {
    idCargo: { type: String },
  },
});

@Component
export default class AlteracaoNormativa extends mixins(UtilsTS, CompProps) {
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;

  tabelasAuxiliares = new TabelasAuxiliaresCargo();
  tiposVinculo: SelectValue[] = [];
  tiposNomenclatura: SelectValue[] = [];
  nomenclaturaInput = "";
  tiposRegimeJuridico: SelectValue[] = [];
  tiposRegimePrevidenciario: SelectValue[] = [];
  tiposNatureza: SelectValue[] = [];
  tiposEscolaridade: SelectValue[] = [];
  tiposSituacao: SelectValue[] = [];
  tiposAtoNormativo: SelectValue[] = [];
  tiposAlteracaoNormativa: SelectValue[] = [];
  tiposVeiculoPublicacao: SelectValue[] = [];
  cargo = new CargoAlterarNormativa();
  temNormativo = false;
  normativoNaoEncontrado = false;
  normativoAdicionado: any[] = [];
  nomenclaturaTextoLivre = false;
  camposNormativo: TableField[] = fieldsNormativoAdicionado;

  get criacaoOuReducaoDeVagas(): boolean {
    return this.cargo.tipoAlteracao == 1 || this.cargo.tipoAlteracao == 2;
  }

  get alteracaoDeDados(): boolean {
    return this.cargo.tipoAlteracao == 3;
  }

  get mostrarInputCargaHoraria(): boolean {
    return (
      this.cargo.vinculo != 1 &&
      this.cargo.vinculo != 2 &&
      this.cargo.vinculo != 7 &&
      this.cargo.vinculo != 9 &&
      this.cargo.vinculo != 11 &&
      this.cargo.vinculo != null
    );
  }

  async handleTipoAlteracaoNormativaChange(): Promise<void> {
    this.observer.reset();
    await this.getCargo();
    await this.carregarNomenclatura();
    this.checkNumeroDeVagas();
  }

  async carregarTabelasAuxiliares(): Promise<void> {
    const response = await cargoService.getTabelasAuxiliares();
    this.tabelasAuxiliares = response.data;
  }

  atualizarInformacoesNormativo(): void {
    const descricaoTipoAtoNormativo =
      this.cargo.normativo.tipoAtoNormativo != null
        ? this.formatTipoAtoNormativo(this.cargo.normativo.tipoAtoNormativo)
        : undefined;
    // this.normativoAdicionado = [];
    this.normativoAdicionado.push({
      numeroNormativo: String(this.cargo.normativo.numeroAtoNormativo ?? ""),
      anoNormativo:
        this.cargo.normativo.anoAtoNormativo != null
          ? String(this.cargo.normativo.anoAtoNormativo)
          : "",
      veiculoNormativo: this.cargo.normativo.veiculoPublicacao,
      dtInicioVigenciaNormativo: this.formatData(
        this.cargo.normativo.dataInicioVigencia ?? ""
      ),
      tipoNormativo: descricaoTipoAtoNormativo ?? "",
    });
  }

  alertaRemoveNormativo() {
    this.$bvModal
      .msgBoxConfirm(
        `Deseja remover o normativo: "${this.cargo.normativo.numeroAtoNormativo}/${this.cargo.normativo.anoAtoNormativo}" ?`,
        {
          buttonSize: "sm",
          cancelTitle: "Cancelar",
          cancelVariant: "outline-secondary",
          okVariant: "secondary",
          centered: true,
          headerBgVariant: "secondary",
          headerTextVariant: "light",
          okTitle: "Confirmar",
          title: "Confirmação de remoção de normativo",
        }
      )
      .then((value) => {
        if (value) this.limparInformacoesNormativo();
      })
      .catch((err) => {
        console.error(
          `Erro ao operar o dialog de alerta de remoção de normativo: ${err}`,
          err
        );
      });
  }

  limparInformacoesNormativo(): void {
    this.normativoAdicionado = [];
    this.cargo.normativo = new NormativoCargo();
    this.temNormativo = false;
  }

  async salvarNormativo(dados: NormativoCargo): Promise<void> {
    this.cargo.normativo = new NormativoCargo({ ...dados });
    this.atualizarInformacoesNormativo();
    this.temNormativo = true;
    this.$bvModal.hide("modal");

    const response = await cargoService.verificarNormativo(
      this.cargo.normativo.numeroAtoNormativo,
      this.cargo.normativo.anoAtoNormativo,
      this.cargo.normativo.tipoAtoNormativo
    );
    this.normativoNaoEncontrado =
      response && response.status != 200 ? true : false;
  }

  async alterarCargo(): Promise<void> {
    try {
      if (!this.temNormativo) {
        this.$toast.error("O normativo é de preenchimento obrigatório.");
        return;
      }

      if (this.nomenclaturaTextoLivre) {
        this.cargo.nomenclaturaCargo = this.nomenclaturaInput;
      }

      let payload: any;
      if (this.criacaoOuReducaoDeVagas) {
        payload = {
          tipoAlteracao: this.cargo.tipoAlteracao,
          codigoCargo: this.cargo.codigoCargo,
          quantidadeVagas: this.cargo.vagasCriadasOuReduzidas,
          normativo: this.cargo.normativo,
        };
      } else if (this.alteracaoDeDados) {
        payload = {
          tipoAlteracao: this.cargo.tipoAlteracao,
          codigoCargo: this.cargo.codigoCargo,
          nomenclaturaCargo: this.cargo.nomenclaturaCargo,
          vinculo: this.cargo.vinculo,
          regimeJuridico: this.cargo.regimeJuridico,
          regimePrevidenciario: this.cargo.regimePrevidenciario,
          especialidade: this.cargo.especialidade,
          area: this.cargo.area,
          escolaridade: this.cargo.escolaridade,
          habilitacaoExigida: this.cargo.habilitacaoExigida,
          naturezaCargo: this.cargo.naturezaCargo,
          idadeMinima: this.cargo.idadeMinima,
          idadeMaxima: this.cargo.idadeMaxima,
          situacaoCargo: this.cargo.situacaoCargo,
          tetoRemuneratorioEspecifico: this.cargo.tetoRemuneratorioEspecifico,
          normativo: this.cargo.normativo,
        };
      } else {
        payload = {
          tipoAlteracao: this.cargo.tipoAlteracao,
          codigoCargo: this.cargo.codigoCargo,
          nomenclaturaCargo: this.cargo.nomenclaturaCargo,
          vinculo: this.cargo.vinculo,
          regimeJuridico: this.cargo.regimeJuridico,
          regimePrevidenciario: this.cargo.regimePrevidenciario,
          especialidade: this.cargo.especialidade,
          area: this.cargo.area,
          escolaridade: this.cargo.escolaridade,
          habilitacaoExigida: this.cargo.habilitacaoExigida,
          naturezaCargo: this.cargo.naturezaCargo,
          idadeMinima: this.cargo.idadeMinima,
          idadeMaxima: this.cargo.idadeMaxima,
          situacaoCargo: this.cargo.situacaoCargo,
          tetoRemuneratorioEspecifico: this.cargo.tetoRemuneratorioEspecifico,
          quantidadeVagas: this.cargo.quantidadeVagas,
          normativo: this.cargo.normativo,
        };
      }

      const response = await cargoService.alterarCargo(payload);
      if (response && response.status == 200) {
        this.$toast.success("Cargo salvo com sucesso");
        this.$router.push("/atos-pessoal/cargos/consulta");
      } else if (response && response.data?.erros) {
        response.data.erros.forEach((erro: string) => this.$toast.error(erro));
      } else {
        this.$toast.error("Erro ao salvar os dados");
      }
    } catch (error: unknown) {
      this.tratarError(error);
    }
  }

  formatTipoAtoNormativo(idTipo: number): string | undefined {
    const tipoAtoNormativo = this.tiposAtoNormativo.find(
      (t) => t.value == idTipo
    );
    if (tipoAtoNormativo?.text) return tipoAtoNormativo.text;
    this.$toast.error("Erro ao formatar tipo de ato normativo");
  }

  async getCargo(): Promise<void> {
    const response = await cargoService.getCargo(this.idCargo);
    if (response && response.status == 200) {
      const c = response.data;
      this.cargo.codigoCargo = c.DeCodigoCargo;
      this.cargo.nomenclaturaCargo = c.DeNomenclaturaCargo;
      this.cargo.vinculo = c.IdTipoVinculo;
      this.cargo.regimeJuridico = c.IdTipoRegimeJuridico;
      this.cargo.regimePrevidenciario = c.IdTipoRegimePrevidenciario;
      this.cargo.naturezaCargo = c.IdNaturezaCargo;
      this.cargo.especialidade = c.DeEspecialidade;
      this.cargo.area = c.DeArea;
      this.cargo.escolaridade = c.IdTipoEscolaridade;
      this.cargo.habilitacaoExigida = c.DeHabilitacaoExigida;
      this.cargo.quantidadeVagas = c.NrQuantidadeVagas;
      this.cargo.idadeMinima = c.NrIdadeMinima;
      this.cargo.idadeMaxima = c.NrIdadeMaxima;
      this.cargo.tetoRemuneratorioEspecifico = c.DeTetoRemuneratorioEspecifico;
      this.cargo.situacaoCargo = c.IdSituacaoCargo;
      this.cargo.cargaHoraria = c.NrCargaHoraria;
    } else {
      this.$toast.error("Erro ao obter os dados do cargo");
      this.$router.push("/atos-pessoal/cargos/consulta");
    }
  }

  async handleVinculoChange(): Promise<void> {
    this.nomenclaturaInput = "";
    this.cargo.nomenclaturaCargo = "";
    this.nomenclaturaTextoLivre = this.cargo.vinculo
      ? [3, 4, 5, 8, 9, 13].includes(this.cargo.vinculo)
      : false;

    if (!this.nomenclaturaTextoLivre) {
      const nomenclaturas = this.tabelasAuxiliares.nomenclaturas.filter(
        (n) => n.IdVinculo == this.cargo.vinculo
      );
      this.tiposNomenclatura = [
        { value: null, text: "SELECIONE UMA OPÇÃO", disabled: true },
        ...nomenclaturas.map((n) => ({
          value: n.Descricao,
          text: n.Descricao,
        })),
      ];
    }

    if (
      this.cargo.vinculo == 12 ||
      (this.cargo.vinculo == 4 &&
        (store.codigoUG == "001111" || store.codigoUG == "002213"))
    ) {
      const naturezas = this.tabelasAuxiliares.tipoNatureza.filter(
        (n) => n.Descricao == "MILITAR"
      );
      this.tiposNatureza = [
        { value: null, text: "SELECIONE UMA OPÇÃO", disabled: true },
        ...naturezas.map((n) => ({ value: n.Id, text: n.Descricao })),
      ];
    } else {
      const naturezas = this.tabelasAuxiliares.tipoNatureza.filter(
        (n) => n.Descricao != "MILITAR"
      );
      this.tiposNatureza = [
        { value: null, text: "SELECIONE UMA OPÇÃO", disabled: true },
        ...naturezas.map((n) => ({ value: n.Id, text: n.Descricao })),
      ];
    }

    const response = await cargoService.buscarRegimesJuridicos(
      this.cargo.vinculo
    );
    if (response && response.status == 200) {
      this.tiposRegimeJuridico = [
        { value: null, text: "SELECIONE UMA OPÇÃO", disabled: true },
        ...response.data.regimesJuridicos.map((n: any) => ({
          value: n.IdTipoRegimeJuridico,
          text: n.DeTipoRegimeJuridico,
        })),
      ];
    } else {
      this.$toast.error("Erro ao buscar regimes jurídicos");
    }

    if (!this.mostrarInputCargaHoraria) this.cargo.cargaHoraria = null;
  }

  async carregarNomenclatura(): Promise<void> {
    const nomenclaturaOriginal = this.cargo.nomenclaturaCargo;
    await this.handleVinculoChange();
    if (this.nomenclaturaTextoLivre) {
      this.nomenclaturaInput = nomenclaturaOriginal;
    } else {
      this.cargo.nomenclaturaCargo = nomenclaturaOriginal.toUpperCase();
    }
  }

  checkNumeroDeVagas(): void {
    const min = 1;
    const max = 99999;
    const qntdVagasInt = parseInt(
      this.cargo.quantidadeVagas.toString().replace(".", "")
    );

    if (qntdVagasInt > max) this.cargo.quantidadeVagas = String(max);
    if (qntdVagasInt < min) this.cargo.quantidadeVagas = String(min);

    const rx = /(\d+)(\d{3})/;
    this.cargo.quantidadeVagas = String(this.cargo.quantidadeVagas).replace(
      /^\d+/,
      function (w) {
        while (rx.test(w)) {
          w = w.replace(rx, "$1.$2");
        }
        return w;
      }
    );
  }

  async verificarNomenclatura(value: string): Promise<void> {
    const response = await cargoService.verificarNomenclatura(value);
    if (response && response.status === 400) {
      this.$bvModal.show("modal-nomenclatura");
    } else if (!response) {
      this.$toast.error("Erro ao verificar a nomenclatura.");
    }
  }

  async fecharModalLegislacoes(enviado = false): Promise<void> {
    if (enviado) {
      this.normativoNaoEncontrado = false;
      this.$bvModal.hide("modal-cadastro-legislacao");
      return;
    }
    const response = await cargoService.verificarNormativo(
      this.cargo.normativo.numeroAtoNormativo,
      this.cargo.normativo.anoAtoNormativo,
      this.cargo.normativo.tipoAtoNormativo
    );
    this.normativoNaoEncontrado =
      response && response.status != 200 ? true : false;
    this.$bvModal.hide("modal-cadastro-legislacao");
  }

  async created(): Promise<void> {
    try {
      store.blockScreen = true;
      await this.carregarTabelasAuxiliares();
      this.tiposVinculo = carregarTipoVinculo(this.tabelasAuxiliares);
      this.tiposRegimeJuridico = carregarTipoRegimeJuridico(
        this.tabelasAuxiliares
      );
      this.tiposRegimePrevidenciario = carregarTipoRegimePrevidenciario(
        this.tabelasAuxiliares
      );
      this.tiposNatureza = carregarTipoNatureza(this.tabelasAuxiliares);
      this.tiposEscolaridade = carregarTipoEscolaridade(this.tabelasAuxiliares);
      this.tiposSituacao = carregarTipoSituacao(this.tabelasAuxiliares);
      this.tiposAtoNormativo = carregarTipoAtoNormativo(this.tabelasAuxiliares);
      this.tiposAlteracaoNormativa = carregarTipoAlteracaoNormativa(
        this.tabelasAuxiliares
      );
      this.tiposVeiculoPublicacao = carregarTipoVeiculoPublicacaoNormativo(
        this.tabelasAuxiliares
      );
      await this.getCargo();
      await this.carregarNomenclatura();
      this.checkNumeroDeVagas();
    } catch (error: unknown) {
      this.tratarError(error);
      console.error("Erro ao carregar dados do cargo:", error);
    } finally {
      store.blockScreen = false;
    }
  }
}
</script>

<style src="./css/main.css">
